
import React, { Fragment, useEffect, useState } from "react";
import { VendorRequestAction } from "../../../constants/AppConstants";
import {
  Button,
  Grid, Checkbox, Select, TextField,
  MenuItem, Chip, ListItemText, Tooltip
} from "@material-ui/core";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import useStyles from "./VendorRequest.css";
import translation from "../../../i18n/i18.json";
import { VendorCreateState } from "../../../reducers/vendor/VendorCreateReducer";
import { RootState } from "../../../reducers";
import { useDispatch, useSelector } from "react-redux";
import { VendorType } from "../../../models/VendorType";
import { VendorCategory } from "../../../models/Master/VendorCategory";
import { RMCategory } from "../../../models/RMCategory";
import { OnBoardingReason } from "../../../models/OnboardingReason";
import { SecondLevelCategory } from "../../../models/SecondLevelCategory";
import { VendorNominated } from "../../../models/VendorNominated";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { UserLoginState } from "../../../reducers/LoginReducer";
import CancelIcon from "@material-ui/icons/Cancel";
import { Company } from "../../../models/Company";
import { Department } from "../../../models/Department";
import { Po } from "../../../models/Po";
import { ReconAC } from "../../../models/ReconAC";
import { FormUtil } from "../../../utils/FormUtil";
import AllActions from "../../../actions";
import FileUpload from "../../../components/FileUpload/FileUpload";
import {
  FieldsLengthConstants, FileUploadTypes, InforDisplyaDuration,
  NavigationPaths, VendorForm1Modes, VendorRequestViewMode, VendorTypeData,
  CompanyCodeData, RequestTypes, AppApprovalPoints, VendorCategoryData,
  VendorOnBoardingReasonData,
  SpendManagedByData
} from "../../../constants/AppConstants";
import { useHistory } from "react-router-dom";
import { FormError } from "../../../models/FormValidation/FormError";
import { FormFieldMeta } from "../../../models/FormValidation/FormFieldMeta";
import ValidationErrors from "../../../components/ErrorList/ValidationErrors";
import { FormValidateData } from "../../../models/FormValidation/FormValidateData";
import { User } from "../../../models/Master/User";
import { VendorAmendService } from "../../../services/VendorAmendService";
import RequestChangePopUp from "../../../components/Vendor/Popup/RequestChangeDialog";
import { VendorDetailService } from "../../../services/VendorDetailService";
import { VendorMasterData } from "../../../services/VendorMasterData";
import { MasterDataService } from "../../../services/MasterDataService";
import { MasterMetaDataService } from "../../../services/MasterMetaDataService";
import { ApprovalPointUtil } from "../../../utils/ApprovalPointUtil";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import { Country } from "../../../models/Country";
import { VendorDetailContactMeta } from "../../../models/VendorDetail/VendorDetailContactMeta";
import { VendorDetailPaymentMeta } from "../../../models/VendorDetail/VendorDetailPaymentMeta";
import { TermsTrade } from "../../../models/TermsTrade";
import { CreditPeriodDays } from "../../../models/CreditPeriodDays";
import { SettlementCurrency } from "../../../models/SettlementCurrency";
import { PaymentMethod } from "../../../models/PaymentMethod";
import { Common } from "../../../utils/Common";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { ProcurementCategorySummary, ProcurementSubcategorySummary } from "../../../models/Master/ProcurementCategorySummary";
import { InstructionKey } from "../../../models/InstructionKey";
import { Util } from "../../../utils/Util";
import { Approver1n2Data } from "../../../models/Approval/Approver1n2Data";
import { CommonRef } from "../../../models/CommonRef";
import { PaymentPurpose } from "../../../models/PaymentPurpose";
import { MasterDataUtil } from "../../../utils/masterData/MasterDataUtil";

const icon = <CheckBoxOutlineBlankIcon />;
const checkedIcon = <CheckBoxIcon />;

export default function VendorRequest(props: any) {

  const state = props.location?.state || {};
  const queryParams = new URLSearchParams(props.location.search || "");
  const isView = state?.isView === true || queryParams.get("isView") === "true";
  const rawActions = state?.allowedActions?.join(",") ?? queryParams.get("actions") ?? "";
  const allowedActions: VendorRequestAction[] = rawActions
    .split(",")
    .map((a: string) => a.trim())
    .map(
      (a: string): VendorRequestAction | undefined =>
        VendorRequestAction[a as keyof typeof VendorRequestAction]
    )
    .filter(
      (a: VendorRequestAction | undefined): a is VendorRequestAction =>
        a !== undefined
    );
  const vendorNo =
    state?.sapVendorNo ??
    queryParams.get("sapVendorNo") ??
    undefined;
  const coCode =
    state?.companyCode ??
    queryParams.get("companyCode") ??
    undefined;

  const poCodes: string[] =
    state?.poCodes ??
    (queryParams.get("poCodes")
      ? queryParams.get("poCodes")!.split(",")
      : []);
  const rawMode = state?.mode ?? queryParams.get("mode");
  const vendorRequestMode: VendorForm1Modes | VendorRequestViewMode =
    rawMode && VendorForm1Modes[rawMode as keyof typeof VendorForm1Modes]
      ? VendorForm1Modes[rawMode as keyof typeof VendorForm1Modes]
      : rawMode && VendorRequestViewMode[rawMode as keyof typeof VendorRequestViewMode]
        ? VendorRequestViewMode[rawMode as keyof typeof VendorRequestViewMode]
        : VendorForm1Modes.VendorInitialCreate;

  // ✅ Page is editable ONLY when not opened via 👁 icon
  const requestId = state?.requestId ?? undefined;
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const vendorId = state ? state.vendorId : undefined;
  const requestNumber = state ? state.requestNumber : undefined;
  const relatedVendorCompanies = state ? state.relatedVendorCompanies : [];
  const createVendor: VendorCreateState = useSelector<RootState, VendorCreateState>((state) => state.vendorCreateDetails);
  const loginUserDetails = useSelector<RootState, UserLoginState>((state) => state.loginDetails);

  const [vendorTypes, setVendorTypes] = useState(Array<VendorType>());
  const [filteredVendorTypes, setFilteredVendorTypes] = useState(Array<VendorType>());
  const [vendorCategories, setVendorCategories] = useState(Array<VendorCategory>());
  const [rmCategories, setRMCategories] = useState(Array<RMCategory>());
  const [vendorOnboardingReasons, setVendorOnboardingReasons] = useState(Array<OnBoardingReason>());
  const [procurementCategories, setProcurementCategories] = useState(Array<ProcurementCategorySummary>());
  const [procurementSubcategories, setProcurementSubCategories] = useState(Array<ProcurementSubcategorySummary>());
  const [procurementSubCategorySummaries, setProcurementSubCategorySummaries] = useState(Array<ProcurementSubcategorySummary>());
  const [secondCategories, setSecondCategories] = useState(Array<SecondLevelCategory>());
  const [vendorNominated, setVendorNominated] = useState(Array<VendorNominated>());
  const [companyCodeList, setCompanyCodeList] = useState(Array<Company>());
  const [departmentList, setDepartmentList] = useState(Array<Department>());
  const [poList, setPoList] = useState(Array<Po>());
  const [filteredPoList, setFilteredPoList] = useState(Array<Po>());
  const [approver1List, setApprover1List] = useState(Array<User>());
  const [approver2List, setApprover2List] = useState(Array<User>());
  const [approver1Lable, setApprover1Lable] = useState("");
  const [approver2Lable, setApprover2Lable] = useState("");
  const [reconAcList, setReconAcList] = useState(Array<VendorNominated>());
  const [formErrors, setFormErrors] = useState<FormError[]>([]);
  const [fistSubmitDone, setFistSubmitDone] = useState(false);
  const [resetScreen, setResetScreen] = useState(false);
  const [openValidateErrDialog, setOpenValidateErrDialog] = useState(false);
  const [openRequestChange, setOpenRequestChange] = useState(false);
  const [requestchangeTitle, setRequestchangeTitle] = useState("");
  const [countries, setCountries] = useState(Array<Country>());
  const [termstrade, setTermstrade] = useState(Array<TermsTrade>());
  const [crediperioddays, setCrediperioddays] = useState(Array<CreditPeriodDays>());
  const [settlementcurrency, setSettlementcurrency] = useState(Array<SettlementCurrency>());
  const [paymentmethod, setPaymentmethod] = useState(Array<PaymentMethod>());
  const [isInitialVendorDetailLoading, setIsInitialVendorDetailLoading] = useState(false);
  const [instructionkeys, setInstructionkey] = useState(Array<InstructionKey>());
  const [spendManagedBys, setSpendManagedBys] = useState(Array<CommonRef>());
  const [paymentpurposes, setPaymentpurposes] = useState(Array<PaymentPurpose>());


  const setDepartmentSelectData = (departments: Department[]) => {
    setDepartmentList(departments.filter((d: Department) => {
      return d.isActive;
    }));
  };

  const setCompanyCodeSelectData = (companyData: Company[]) => {
    setCompanyCodeList(companyData);
  };

  // const getFilteredPoList = () => {
  //   if (poList && createVendor.VendorCategoryId == VendorCategoryData.RM) {
  //     if (createVendor.IsBulk) {
  //       return poList.filter(p => {
  //         return p.code.substring(p.code.length - 1) != "2";
  //       });
  //     } else {
  //       return poList.filter(p => {
  //         return p.code.substring(p.code.length - 1) == "2";
  //       });
  //     }
  //   } else {
  //     return createVendor.VendorCategoryId > 0 ? poList : [];
  //   }
  // }

  const clearApproverData = () => {
    setApprover1List([]);
    setApprover2List([]);
    setApprover1Lable("");
    setApprover2Lable("");
  }

  const getErrorState = (input: string) => {
    var errIndex = formErrors.findIndex(function (row) {
      return row.fieldName === input && row.errorMsg;
    });
    return errIndex !== -1 ? true : false;
  };

  const validateData = () => {
    setFormErrors([]);
    const validateFieldsData: Array<FormFieldMeta> = [
      {
        fieldName: "DepartmentId",
        isRequired: true,
        reuiredMsg: "Department is required",
        isList: true,
      },
      {
        fieldName: "CompanyCode",
        isRequired: true,
        reuiredMsg: "Company Code is required",
        isList: true,
      },
      {
        fieldName: "PoCodes",
        isRequired: isPoRequired(),
        reuiredMsg: "Po Code is required",
        isList: true,
      },
      {
        fieldName: "FirstApprovers",
        isRequired: !isRmOrNonRmOrServices() || isServicesBySbu(),
        reuiredMsg: approver1Lable + " required",
        isList: true,
      },
      {
        fieldName: "SecondApprovers",
        isRequired: !isRmOrNonRmOrServices(),
        reuiredMsg: approver2Lable + " required",
        isList: true,
      },
      {
        fieldName: "VendorNominatedBy",
        isRequired: false,
        reuiredMsg: "Vendor Nominated By is required",
      },
      {
        fieldName: "VendorName",
        isRequired: true,
        reuiredMsg: "Vendor Name is required",
      },
      {
        fieldName: "VendorCategoryId",
        isRequired: true,
        reuiredMsg: "Vendor Category is required",
      },
      {
        fieldName: "VendorType",
        isRequired: true,
        reuiredMsg: "Vendor Type is required",
      },
      {
        fieldName: "TypeSubCategory",
        isRequired: true,
        reuiredMsg: "Type SubCategory is required",
      },
      {
        fieldName: "ReconAC",
        isRequired: true,
        reuiredMsg: "Recon/AC is required",
      },
      {
        fieldName: "MobileNumber",
        isRequired: true,
        reuiredMsg: "MobileNumber is required",
        formatFunc: createVendor.MobileNumber
          ? FormUtil.isValidMobileNumberForSms.bind(createVendor.MobileNumber)
          : undefined,
        formatMsg: translation.vendor_crete_form1_mobilenformt_error,
      },
      {
        fieldName: "Email",
        isRequired: createVendor.IsVendorFillForm2,
        reuiredMsg: "Email is required",
        formatFunc: createVendor.Email
          ? FormUtil.isValidEmail.bind(createVendor.Email)
          : undefined,
        formatMsg: translation.vendor_crete_form1_emailfomat_error,
      },
      {
        fieldName: "AddressCoutry",
        isRequired: true,
        reuiredMsg: "Country is required",
      },
      {
        fieldName: "PrefPayMethod",
        isRequired: true,
        isList: true,
        reuiredMsg: "Preferred Payment Method is required",
      },
      {
        fieldName: "CreditPeriodDays",
        isRequired: true,
        reuiredMsg: "Credit Period Days is required",
      },
      {
        fieldName: "orderCurrency",
        isRequired: isPORequest(),
        reuiredMsg: "Order Currency is required",
      },
      {
        fieldName: "TermsOfTrade",
        isRequired: isPORequest(),
        reuiredMsg: "Terms Of Trade is required",
      },
      {
        fieldName: "RMCategoryIds",
        isRequired: createVendor.VendorCategoryId == VendorCategoryData.RM ? true : false,
        reuiredMsg: "RM Category is required",
        isList: true
      },
      {
        fieldName: "OnBoardReasonIds",
        isRequired: isRmOrNonRmOrServices(),
        reuiredMsg: "Onboarding Reason is required",
        isList: true
      },
      {
        fieldName: "OnBoardReasonDescription",
        isRequired: createVendor.VendorCategoryId == VendorCategoryData.RM ? true : false,
        reuiredMsg: "Onboarding Description is required",
      },
      {
        fieldName: "ProcurementCategoryIds",
        isRequired: isNonRmOrService(createVendor.VendorCategoryId),
        reuiredMsg: "Procurement Category is required",
        isList: true
      },
      {
        fieldName: "ProcurementSubcategoryIds",
        isRequired: isNonRmOrService(createVendor.VendorCategoryId),
        reuiredMsg: "Procurement Subcategory is required",
        isList: true
      },
      {
        fieldName: "SpendManagedById",
        isRequired: false,//isSpendManagedByRequired(),
        reuiredMsg: "Spend Managed By is required",
        isList: true
      }
    ];
    let formValidateData: FormValidateData = FormUtil.validateFields(
      validateFieldsData,
      createVendor
    );
    //Proc sub cat list
    if (isNonRmOrService(createVendor.VendorCategoryId)) {
      if (!isProcurementSubCatComplete()) {
        formValidateData.errorsList.push({ fieldName: "ProcurementSubcategoryIds", errorMsg: "Procurement Subcategories are incomplete." });
        formValidateData.isValid = false;
      }
    }
    //Onboarding reason doc
    if(createVendor.VendorCategoryId == VendorCategoryData.RM 
      && !(createVendor.OnboardReasonFile.fileId > 0)){
      formValidateData.errorsList.push({fieldName:"OnboardReasonFile", errorMsg: "Onboarding Reason Document is required"});
      formValidateData.isValid = false; 
    }
    setFormErrors(formValidateData.errorsList);
    return formValidateData.isValid;
  };

  const showLoadingMask = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  console.log("FULL URL:", props.location.pathname + props.location.search);
  console.log("RAW SEARCH:", props.location.search)

  const compeleteRequest = (
    success: boolean,
    message?: string,
    duration?: number
  ) => {
    //wait for next tic
    if(!isInitialVendorDetailLoading){
      dispatch(AllActions.backDropActions.closeBackDrop());
      if (message) {
        let messageduration = duration ? duration : InforDisplyaDuration.common;
        if (success) {
          dispatch(AllActions.infoActions.openInforSuccess(message, messageduration!));
        } else {
          dispatch(AllActions.infoActions.openInforError(message, messageduration!));
        }
      }
    }
  };

  useEffect(() => {
    if (isInitialVendorDetailLoading) {
      showLoadingMask();
    }else{
      compeleteRequest(true);
    }
  }, [isInitialVendorDetailLoading]);

  useEffect(() => {
    if (fistSubmitDone) {
      validateData();
    }
  }, [createVendor]);

  useEffect(() => {
    if (createVendor.CompanyCode && createVendor.CompanyCode.length !== 0) {
      if (!isInitialVendorDetailLoading) {
        showLoadingMask();
        Promise.allSettled([
          getPoData(createVendor.CompanyCode),
          getPromisePaymentDetailMetaData(createVendor.CompanyCodeCountry),
          getPromiseInstructionKey(createVendor.CompanyCodeCountry),
          createVendor.VendorType && createVendor.VendorType !== ""
            ? getReconAc(createVendor.CompanyCode, createVendor.VendorType)
            : undefined,
        ]).then(() => {
          if (!isInitialVendorDetailLoading && isEditableMode()) {
            compeleteRequest(true);
          }
        });
      }
    } else {
      setPoList([]);
      clearApproverData();
      setReconAcList([]);
    }
  }, [createVendor.CompanyCode]);

  useEffect(() => {
    if (createVendor.VendorType && createVendor.VendorType !== "") {
      if (!isInitialVendorDetailLoading) {
        createVendor.TypeSubCategory = '';
        createVendor.ReconAC = '';
        showLoadingMask();
        Promise.allSettled([
          getSecondLevelCategory(createVendor.VendorType),
          getReconAc(createVendor.CompanyCode, createVendor.VendorType),
        ]).then(() => {
          if (!isInitialVendorDetailLoading && isEditableMode()) {
            compeleteRequest(true);
          }
        });
      }
    } else {
      createVendor.TypeSubCategory = '';
      createVendor.ReconAC = '';
      setSecondCategories([]);
      setReconAcList([]);
    }
  }, [createVendor.VendorType]);

  useEffect(() => {
    setFilteredVendorTypes(getVendorTypeByCategory(createVendor.VendorCategoryId));
  }, [vendorTypes, createVendor.VendorType, createVendor.VendorCategoryId]);

  useEffect(() => {
    if (createVendor.VendorCategoryId > 0) {
      if (!isInitialVendorDetailLoading) {
        createVendor.OnBoardReasonIds = [];
        createVendor.OnBoardReasonDescription = '';
        createVendor.OnboardReasonFile = { fileId: 0, fileName: "", filePath: "" };
        createVendor.RMCategoryIds = [];
        createVendor.ProcurementCategoryIds = [];
        createVendor.ProcurementSubcategoryIds = [];
        createVendor.VendorType = '';
        createVendor.SpendManagedById = 0;
        createVendor.PoCodes = [];
        clearApproverData();
        showLoadingMask();
        Promise.allSettled([
          getPromiseOnboardingReasons(createVendor.VendorCategoryId),
          getPromiseProcurmentSubcategoryData(createVendor.VendorCategoryId),
          getPromiseRMCategoryData(createVendor.VendorCategoryId)
          //getPromiseSpendManagedByData(createVendor.VendorCategoryId)
        ]).then(() => {
          setProcurementSubCategories([]);
          if (!isInitialVendorDetailLoading && isEditableMode()) {
            compeleteRequest(true);
          }
        });
      }
    } else {
      createVendor.OnBoardReasonIds = [];
      createVendor.OnBoardReasonDescription = '';
      createVendor.OnboardReasonFile = { fileId: 0, fileName: "", filePath: "" };
      createVendor.RMCategoryIds = [];
      createVendor.ProcurementCategoryIds = [];
      createVendor.ProcurementSubcategoryIds = [];
      createVendor.VendorType = '';
      setVendorOnboardingReasons([]);
      setProcurementCategories([]);
      setProcurementSubCategories([]);
    }
  }, [createVendor.VendorCategoryId]);

  useEffect(() => {
    let fltPoList = Util.getSampleBulkPoList(poList, createVendor.VendorCategoryId, createVendor.IsBulk, RequestTypes.VendorCreate); 
    //getFilteredPoList();
    setFilteredPoList(fltPoList);
    //if others selected clear
    if (!isInitialVendorDetailLoading) {
      createVendor.PoCodes = createVendor.PoCodes.filter(p => {
        return fltPoList.find(r => r.code == p);
      });
    }
  }, [createVendor.VendorCategoryId, createVendor.IsBulk, poList]);

  useEffect(() => {
    if (createVendor.ProcurementCategoryIds && createVendor.ProcurementCategoryIds.length > 0) {
      if (!isInitialVendorDetailLoading) {
        createVendor.ProcurementSubcategoryIds = [];
      }
      let procurementSubcats: ProcurementSubcategorySummary[] = [];
      procurementSubCategorySummaries.forEach(p => {
        if (createVendor.ProcurementCategoryIds.find(e => e == p.procurmentCategoryId)) {
          procurementSubcats.push(p);
        }
      });
      setProcurementSubCategories(procurementSubcats);
    } else {
      createVendor.ProcurementSubcategoryIds = [];
      setProcurementSubCategories([]);
    }
  }, [createVendor.ProcurementCategoryIds, procurementSubCategorySummaries]);

  useEffect(() => {
    if (createVendor.ProcurementSubcategoryIds && createVendor.ProcurementSubcategoryIds.length > 0) {
      if (!isInitialVendorDetailLoading) {
        let procSubCat = procurementSubCategorySummaries.find(v => v.procurmentSubcategoryId == createVendor.ProcurementSubcategoryIds[0]);
        dispatch(AllActions.vendorCreationActions.updateDataField("SpendManagedById", procSubCat ? procSubCat.spendManagedById : null));
      }
    } else {
      dispatch(AllActions.vendorCreationActions.updateDataField("SpendManagedById", null));
    }
  }, [createVendor.ProcurementSubcategoryIds]);

  useEffect(() => {
    if (createVendor.CompanyCode && createVendor.CompanyCode.length > 0
      && createVendor.VendorCategoryId > 0) {
      if (!isInitialVendorDetailLoading) {
        showLoadingMask();
        getApproverData(createVendor.CompanyCode, createVendor.VendorCategoryId, createVendor.OnBoardReasonIds
          , createVendor.IsBulk, createVendor.SpendManagedById)
          .then(() => {
            if(isEditableMode())
              compeleteRequest(true);
          });
      }
    } else {
      clearApproverData();
    }
  }, [createVendor.CompanyCode, createVendor.VendorCategoryId, createVendor.IsBulk, createVendor.OnBoardReasonIds, createVendor.SpendManagedById]);

  const toFormMode = (
    mode: VendorForm1Modes | VendorRequestViewMode | undefined
  ): VendorForm1Modes | undefined => {
    if (!mode) return undefined;

    // ✅ Already a form mode
    if (Object.values(VendorForm1Modes).includes(mode as VendorForm1Modes)) {
      return mode as VendorForm1Modes;
    }

    // ✅ Explicitly ignore ALL view modes
    return undefined;
  };

  const requestChangeMode = toFormMode(vendorRequestMode);

  const getPoData = function (companycode: string) {
    return VendorDetailService.getPO(
      companycode,
      function (poData: Array<Po>) {
        setPoList(poData);
      },
      function () {
        setPoList([]);
      }
    );
  };

  const isPoRequired = () => {
    return (createVendor.VendorCategoryId === VendorCategoryData.RM || createVendor.VendorCategoryId === VendorCategoryData.NonRM)
      && createVendor.CompanyCode !== CompanyCodeData.ACMEusa;
  };

  const isRmOrNonRmOrServices = () => {
    return createVendor.VendorCategoryId == VendorCategoryData.NonRM
      || createVendor.VendorCategoryId == VendorCategoryData.Services
      || createVendor.VendorCategoryId == VendorCategoryData.RM;
  };

  const isServicesBySbu = () => {
    return createVendor.VendorCategoryId == VendorCategoryData.Services
      && (createVendor.SpendManagedById == SpendManagedByData.SBU 
          || createVendor.SpendManagedById == SpendManagedByData.GroupProcurementAndSBU );
  };

  const isPORequest = () => {
    return createVendor.PoCodes && createVendor.PoCodes.length > 0;
  };

  const isNonRmOrService = (vendorCatId : number) => {
    return vendorCatId == VendorCategoryData.NonRM
      || vendorCatId == VendorCategoryData.Services;
  };

  const isRmOrNonRm = (vendorCatId : number) => {
    return vendorCatId == VendorCategoryData.NonRM
      || vendorCatId == VendorCategoryData.RM;
  };


  const isProcurementSubCatComplete = () => {
    return procurementSubCategorySummaries.filter(v => createVendor.ProcurementSubcategoryIds.indexOf(v.procurmentSubcategoryId) > -1)
      .map(v => v.procurmentCategoryId).filter((value, index, array) => array.indexOf(value) === index).length < createVendor.ProcurementCategoryIds.length
      ? false : true;
  };

  const getApproverData = (companyCode: string, vendorCategoryId: number, onBoardReasonIds: number[], isBulk: boolean, spendManagedById: number | null) => {
    let loadApprovers = false;
    if(companyCode && vendorCategoryId){
      if((isNonRmOrService(vendorCategoryId))){//If RM Approvers not selected
        if(spendManagedById && spendManagedById > 0){
          loadApprovers = true;
        }
      } else if(vendorCategoryId != VendorCategoryData.RM){
        loadApprovers = true;
      }
    }
    if(loadApprovers){
      return ApprovalPointUtil.getApproverData(companyCode, vendorCategoryId, onBoardReasonIds, isBulk
      , spendManagedById, createVendor.RequestTypeId
      , (approver1n2Data: Approver1n2Data) => {
        setApprover1List(approver1n2Data.approver1List);
        setApprover2List(approver1n2Data.approver2List);
        setApprover1Lable(approver1n2Data.approver1Lable);
        setApprover2Lable(approver1n2Data.approver2Lable);
      });
    }else{
      clearApproverData();
      return Promise.resolve();
    }
  };

  const getPromiseRMCategoryData = (vendorCategoryId: number) => {
    return vendorCategoryId == VendorCategoryData.RM
      ? MasterMetaDataService.getRMCategories(
        function (userRmCategoryList: Array<RMCategory>) {
          setRMCategories(userRmCategoryList);
        },
        function () {
          setRMCategories([]);
        }
      )
      : Promise.resolve([]);
  };
  const getPromiseOnboardingReasons = (vendorCategoryId: number) => {
    return MasterMetaDataService.getOnBoardingReasons(
      vendorCategoryId,
      function (onboardingReasonList: Array<OnBoardingReason>) {
        setVendorOnboardingReasons(onboardingReasonList);
      },
      function () {
        setVendorOnboardingReasons([]);
      }
    );
  };
  const getPromiseProcurmentSubcategoryData = (vendorCategoryId: number) => {
    return (isNonRmOrService(vendorCategoryId))
      ? MasterDataService.getProcurementSubcategorySummaries(
        createVendor.RequestId,
        vendorCategoryId,
        function (procurementCatList: Array<ProcurementSubcategorySummary>) {
          setProcurementSubCategorySummaries(Util.sortObjByString(procurementCatList, "procurmentCategoryName") as ProcurementSubcategorySummary[]);
          setProcurementCategories(MasterDataUtil.getProcurementCategories(procurementCatList));
          // let procurementCats: ProcurementCategorySummary[] = [];
          // procurementCatList.forEach(p => {
          //   if (!procurementCats.find(e => e.procurmentCategoryId == p.procurmentCategoryId)) {
          //     procurementCats.push({
          //       vendorCategoryId: p.vendorCategoryId,
          //       procurmentCategoryId: p.procurmentCategoryId,
          //       procurmentCategoryName: p.procurmentCategoryName
          //     });
          //   }
          // });
          // setProcurementCategories(Util.sortObjByString(procurementCats, "procurmentCategoryName") as ProcurementCategorySummary[]);
        },
        function () {
          setProcurementSubCategorySummaries([]);
        }
      )
      : Promise.resolve([]);
  };

  const getSecondLevelCategory = (vendorType: string) => {
    //prepareForRequest();
    return VendorDetailService.getSecondLevelCategory(
      //createVendor.VendorType,
      vendorType,
      function (secondCategoryData: Array<SecondLevelCategory>) {
        //console.log(secondCategoryData);
        setSecondCategories(secondCategoryData);
        //compeleteRequest(true);
      },
      function () {
        //console.log(error);
        setSecondCategories([]);
        //compeleteRequest(false);
      }
    );
  };

  //used only for amend
  const addMissingReconAc = (reconACData: Array<ReconAC>, reconAc: string) => {
    let matchingRecon = reconACData.find((recon) => {
      return recon.code === reconAc;
    });
    if (!matchingRecon) {
      reconACData.push({ code: reconAc, name: reconAc });
    }
  }

  const getReconAc = (companycode: string, vendorType: string) => {
    return VendorDetailService.getReconAC(
      companycode,
      vendorType,
      function (reconACData: Array<ReconAC>) {
        if (vendorRequestMode === VendorForm1Modes.VendorInialAmend) {
          addMissingReconAc(reconACData, createVendor.ReconAC);
        }
        setReconAcList(reconACData);
      },
      function () {
        setReconAcList([]);
      }
    );
  };

  const getCompanyCodeObj = (coCode: string) => {
    return companyCodeList.find(co => {
      return co.code === coCode;
    });
  };

  const getVendorTypeByCategory = (categoryId: number) => {
    return categoryId == VendorCategoryData.RM ? vendorTypes.filter(v => v.code == VendorTypeData.RMProductionRelated)
      : categoryId == VendorCategoryData.NonRM ? vendorTypes.filter(v => v.code == VendorTypeData.FixedAssetsConsumables)
        : categoryId == VendorCategoryData.Services ? vendorTypes.filter(v => v.code == VendorTypeData.Services
          || v.code == VendorTypeData.FreightForwarder)
          : categoryId == VendorCategoryData.AffiliatedVendorswithinMAS ? vendorTypes.filter(v => v.code == VendorTypeData.AffiliatedVendorsWithinMAS)
            : categoryId == VendorCategoryData.Employee ? vendorTypes.filter(v => v.code == VendorTypeData.Employee)
              : categoryId == VendorCategoryData.Carriers ? vendorTypes.filter(v => v.code == VendorTypeData.Carriers)
                : [];
  }

  const isCustomerNominatedOrInnovation = (onBoardingReasonIds: number[]) => {
    return onBoardingReasonIds && (onBoardingReasonIds.find(v => v == VendorOnBoardingReasonData.CustomerNominated
      || v == VendorOnBoardingReasonData.Innovation))
      ? true : false;
  }

  const isOnboardingReasonActive = (reasonId: number) => {
    return (!createVendor.OnBoardReasonIds || createVendor.OnBoardReasonIds.length == 0
      || (isCustomerNominatedOrInnovation(createVendor.OnBoardReasonIds) && isCustomerNominatedOrInnovation([reasonId]))
      || (!isCustomerNominatedOrInnovation(createVendor.OnBoardReasonIds) && !isCustomerNominatedOrInnovation([reasonId])))
      ? true : false;
  }

  const handleChange = (input: string) => (e: any) => {
    if (input === "CompanyCode") {
      let coCodeObj = getCompanyCodeObj(e.target.value);
      dispatch(AllActions.vendorCreationActions.updateDataField("CompanyCodeCountry", coCodeObj ? coCodeObj.countryCode : ""));
      dispatch(AllActions.vendorCreationActions.updateDataField(input, coCodeObj ? coCodeObj.code : ""));
      //clear existing Po data from dropdown
      dispatch(AllActions.vendorCreationActions.updateDataField("PoCodes", []));
      dispatch(AllActions.vendorCreationActions.updateDataField("HodApprovers", []));
      dispatch(AllActions.vendorCreationActions.updateDataField("ExcoApprovers", []));
    } else if (input === "PoCodes") {
      dispatch(AllActions.vendorCreationActions.updateDataField(input, e.target.value as string[]));
    } else if (input === "HodApprovers") {
      dispatch(AllActions.vendorCreationActions.updateDataField(input, e.target.value as string[]));
    }
    else if (input === "ExcoApprovers") {
      dispatch(AllActions.vendorCreationActions.updateDataField(input, e.target.value as string[]));
    } else if (input === "ReconAC") {
      dispatch(AllActions.vendorCreationActions.updateDataField(input, e.target.value));
    } else if (input === "IsVendorFillForm2" || input === "isForeignSupplier" || input == "IsUrgentRequest") {
      dispatch(AllActions.vendorCreationActions.updateDataField(input, e.target.checked));
    } else if (input === "VendorType") {
      //if employee vendor clear purge orgs
      if (e.target.value === VendorTypeData.Employee) {
        //clear existing Po data from dropdown
        dispatch(AllActions.vendorCreationActions.updateDataField("PoCodes", []));
      }
      dispatch(AllActions.vendorCreationActions.updateDataField(input, e.target.value));
    } else if (input === "MobileNumber") {
      var re = /^[1-9][0-9]*$/im;
      if (e.target.value === '' || re.test(e.target.value)) {
        dispatch(AllActions.vendorCreationActions.updateDataField(input, e.target.value));
      }
    } else if (input === "AddressCoutry") {

    } else if (input === "OnBoardReasonIds") {
      let newValue = e.target.value
        ? e.target.value.find((v: number) => !createVendor.OnBoardReasonIds.includes(v))
        : null;
      if (!(newValue && createVendor.OnBoardReasonIds.length > 0) //delete or first value
        || (isCustomerNominatedOrInnovation(createVendor.OnBoardReasonIds) && isCustomerNominatedOrInnovation([newValue]))
        || (!isCustomerNominatedOrInnovation(createVendor.OnBoardReasonIds) && !isCustomerNominatedOrInnovation([newValue]))) {
        dispatch(AllActions.vendorCreationActions.updateDataField(input, e.target.value));
      }
      else {
        //not allowed
        dispatch(AllActions.infoActions.openInforError(translation.vendor_crete_form1_onboarding_reason_not_allowed_msg, InforDisplyaDuration.common));
      }
    }
    else if (input === "IsBulk") {
      dispatch(AllActions.vendorCreationActions.updateDataField(input, e.target.value == "true" ? true : false));
    } 
    // else if (input === "RMCategoryIds") {
    //   dispatch(AllActions.vendorCreationActions.updateDataField(input, e.target.value ? [e.target.value] : []));
    // }
    else if (input === "RMCategoryIds" || input === "ProcurementCategoryIds" || input === "ProcurementSubcategoryIds") {
      dispatch(AllActions.vendorCreationActions.updateDataField(input, e.target.value ? [e.target.value] : []));
    }
    // else if (input === "ProcurementSubcategoryIds") {
    //   dispatch(AllActions.vendorCreationActions.updateDataField(input, e.target.value ? [e.target.value] : []));
    // }
    else {
      dispatch(AllActions.vendorCreationActions.updateDataField(input, e.target.value));
    }
  };

  const handleDelete = (e: React.MouseEvent, value: any, input: string) => {
    e.preventDefault();
    if (input === "CompanyCode") {
      dispatch(AllActions.vendorCreationActions.removeFromCompanyCodes(value));
    } else if (input === "PoCodes") {
      dispatch(AllActions.vendorCreationActions.removeFromPoCodes(value));
    } else if (input === "FirstApprovers") {
      dispatch(AllActions.vendorCreationActions.removeFromApporver1(value));
    } else if (input === "SecondApprovers") {
      dispatch(AllActions.vendorCreationActions.removeFromApporver2(value));
    } else if (input === "PrefPayMethod") {
      dispatch(AllActions.vendorCreationActions.removeFromPrefPayMethod(value));
    } else if (input === "OnBoardReasonIds") {
      dispatch(AllActions.vendorCreationActions.removeFromOnBoardReason(value));
    } else if (input === "RMCategory") {
      dispatch(AllActions.vendorCreationActions.removeFromRMCategory(value));
    } else if (input === "ProcurementCategoryIds") {
      dispatch(AllActions.vendorCreationActions.removeFromProcurementCategory(value));
    } else if (input === "ProcurementSubcategoryIds") {
      dispatch(AllActions.vendorCreationActions.removeFromProcurementSubcategory(value));
    }
  };

  const navigateToVendorDetail = (
    vendorId: any,
    vendorNo: string,
    coCode: string,
    poCode: string,
    requestId: any,
    isForceEdit: boolean,
    detailmode: VendorRequestViewMode | VendorForm1Modes,
    requestNo: any
  ) => {
    dispatch(AllActions.vendorCreationActions.resetRequestDetails(""));
    dispatch(AllActions.vendorDetailActions.resetVendorDetails());
    history.push(NavigationPaths.VendorDetail, {
      vendorId: vendorId,
      sAPVendorNo: vendorNo,
      coCode: coCode,
      poCode: poCode,
      requestId: requestId,
      isForceEdit: isForceEdit,
      mode: detailmode,
      requestNo: requestNo,
    });
  };

  const handleSubmit = () => {
    if (isView) return; // ✅ HARD STOP
    setFistSubmitDone(true);
    if (validateData()) {
      showLoadingMask();
      VendorDetailService.createVendor(
        createVendor,
        function (vendorData: VendorCreateState) {
          //console.log(vendorData);
          compeleteRequest(
            true,
            translation.vendor_crete_form1_submit_success_msg +
            vendorData.requestNo
          );
          setResetScreen(true);
          if (!vendorData.isVendorFillForm2) {
            navigateToVendorDetail(
              vendorData.vendorId,
              "",
              "",
              "",
              vendorData.requestId,
              false,
              (vendorData.requestTypeId === RequestTypes.VendorAmend ? VendorRequestViewMode.VendorAmend : VendorRequestViewMode.VendorCreate),
              vendorData.requestNo
            );
          }
        },
        function () {
          //console.log(error);
          compeleteRequest(
            false,
            translation.vendor_crete_form1_submit_error_msg
          );
        }
      );
    } else {
      //show errors list
      setOpenValidateErrDialog(true);
    }
  };

  const getPromisePreferedPaymentMethods = (
    cocode: string,
    addressCountry: string,
    onSuccess: Function,
    onError: Function
  ) => {
    return VendorMasterData.getPreferedPaymentMethods(
      cocode,
      addressCountry,
      function (paymethodsList: Array<PaymentMethod>) {
        const i = paymethodsList.map((i: any) => i.code).indexOf('H');
        if (i > 0) {
          paymethodsList.splice(i, 1);
        }
        onSuccess(paymethodsList);
      },
      function (error: Error) {
        onError(error);
      }
    );
  };

  const getPromisePaymentDetailMetaData = (coCountryCode: string) => {
    return VendorMasterData.getPaymentDetailMetaData(
      coCountryCode,
      function (paymentData: VendorDetailPaymentMeta) {
        setTermstrade(paymentData.termsOfTrades);
        setCrediperioddays(paymentData.creditPeriodDays);
        setSettlementcurrency(paymentData.settlementCurencies);
      },
      function () {
        setTermstrade([]);
        setCrediperioddays([]);
        setSettlementcurrency([]);
      }
    );
  };

  const getPromiseContactDetailMetaData = () => {
    return VendorMasterData.getContactDetailMetaData(
      function (contactData: VendorDetailContactMeta) {
        setCountries(contactData.country);
      },
      function () {
        setCountries([]);
      }
    );
  };

  const getPromiseDepartment = () => {
    return VendorMasterData.getDepartments(
      function (departmentData: Array<Department>) {
        setDepartmentSelectData(departmentData);
      },
      function () {
        setDepartmentSelectData([]);
      }
    );
  };

  const getPromisePurposeOfPayment = () => {
    return VendorMasterData.getPurposeOfPaymentData(
      function (purposeOfpaymentData: Array<PaymentPurpose>) {
        setPaymentpurposes(purposeOfpaymentData);
      },
      function (error: Error) {
        console.log(error);
        setPaymentpurposes([]);
      }
    );
  };

  const getPromiseCompany = () => {
    return VendorDetailService.getCompany(
      function (companyData: Array<Company>) {
        let compData = companyData
          ? companyData.filter((c) => {
            return (ApprovalPointUtil.isUserPermitedApprovalPoint(c.code, [AppApprovalPoints.VCInitial])//TODO : tmp remove until ACME golive
              || ApprovalPointUtil.isUserPermitedApprovalPoint(c.code, [AppApprovalPoints.VAVendorFill]));
          })
          : [];
        setCompanyCodeSelectData(compData);
      },
      function () {
        setCompanyCodeSelectData([]);
      }
    );
  };

  const getPromiseVendorNominatedBy = () => {
    return VendorDetailService.getVendorNominatedBy(
      function (vendorNominatedData: Array<VendorNominated>) {
        setVendorNominated(vendorNominatedData);
      },
      function () {
        setVendorNominated([]);
      }
    );
  };

  const getPromiseVendorTypes = () => {
    return VendorDetailService.getVendorTypes(
      function (vendorTypesData: Array<VendorType>) {
        setVendorTypes(vendorTypesData);
      },
      function () {
        setVendorTypes([]);
      }
    );
  };

  const getPromiseVendorCategories = () => {
    MasterDataService.getVendorCategories(
      function (vendorCategoryListAll: Array<VendorCategory>) {
        setVendorCategories(vendorCategoryListAll);
      },
      function () {
        setVendorCategories([]);
      }
    );
  };

  const getPromiseInstructionKey = (companyCodeCountry: string) => {
    return VendorAmendService.getInstructionKeyData(
      companyCodeCountry,
      function (instructionKeys: Array<InstructionKey>) {
        setInstructionkey(instructionKeys);
      },
      function (error: Error) {
        console.log(error);
        setInstructionkey([]);
      }
    );
  };

  const onVendorDataLoadSuccess = (vendorRequestData: VendorCreateState) => {
    dispatch({
      type: "ON_SUCCESS_VENDOR_REQUEST_GET",
      payload: vendorRequestData,
    });
    getInitialMetaData(vendorRequestData);
  };

  const onVendorDataLoadFail = () => {
    setIsInitialVendorDetailLoading(false);
    // compeleteRequest(false);
  };

  const getInitialMetaData = (vendorRequestData: VendorCreateState | null) => {
    Promise.allSettled([
      getPromiseDepartment(),
      getPromiseCompany(),
      getPromiseVendorNominatedBy(),
      getPromiseVendorTypes(),
      getPromiseContactDetailMetaData(),
      getPromiseVendorCategories(),
      getPromisePurposeOfPayment(),
      vendorRequestData && vendorRequestData.companyCode
        && vendorRequestData.companyCode.length !== 0
        ? getPoData(vendorRequestData.companyCode)
        : undefined,
      vendorRequestData && vendorRequestData.vendorType
        && vendorRequestData.vendorType !== ""
        ? getSecondLevelCategory(vendorRequestData.vendorType)
        : undefined,
      vendorRequestData && vendorRequestData.vendorType
        && vendorRequestData.vendorType !== ""
        ? getReconAc(
          vendorRequestData.companyCode,
          vendorRequestData.vendorType)
        : undefined,
      vendorRequestData && vendorRequestData.companyCodeCountry
        && vendorRequestData.companyCodeCountry !== ""
        ? getPromisePaymentDetailMetaData(
          vendorRequestData.companyCodeCountry)
        : undefined,
      vendorRequestData && vendorRequestData.companyCodeCountry
        && vendorRequestData.companyCodeCountry !== ""
        ? getPromiseInstructionKey(
          vendorRequestData.companyCodeCountry)
        : undefined,  
      vendorRequestData && vendorRequestData.vendorCategoryId
        ? getPromiseRMCategoryData(vendorRequestData.vendorCategoryId)
        : undefined,
      vendorRequestData && vendorRequestData.vendorCategoryId
        ? getPromiseOnboardingReasons(vendorRequestData.vendorCategoryId)
        : undefined,
      vendorRequestData && vendorRequestData.vendorCategoryId
        ? getPromiseProcurmentSubcategoryData(vendorRequestData.vendorCategoryId)
        : undefined
    ]).then(() => {
      createVendor.RequestTypeId = vendorRequestMode == VendorForm1Modes.VendorInitialCreate ? RequestTypes.VendorCreate
        : vendorRequestMode == VendorForm1Modes.VendorInialAmend ? RequestTypes.VendorAmend
          : vendorRequestMode == VendorForm1Modes.VendorInialExtend ? RequestTypes.VendorExtend
            : vendorRequestMode == VendorForm1Modes.VendorInialBlock ? RequestTypes.VendorBlock
              : vendorRequestMode == VendorForm1Modes.VendorInitialIndividualPay ? RequestTypes.VendorIndividualPay
                : 0;
      if (vendorRequestData && vendorRequestData.vendorCategoryId) {
        //setFilteredVendorTypes(getVendorTypeByCategory(vendorTypes, vendorRequestData.vendorCategoryId));  
        getApproverData(vendorRequestData.companyCode, vendorRequestData.vendorCategoryId, vendorRequestData.onBoardReasonIds
          , vendorRequestData.isBulk, vendorRequestData.spendManagedById);
      }
      setIsInitialVendorDetailLoading(false);
      // compeleteRequest(true);
    });
  };

  //const shouldLoadExistingVendor = isView || vendorRequestMode !== VendorForm1Modes.VendorInitialCreate;

  //TODO: remove one init effects
  useEffect(() => {
    //showLoadingMask();
    setIsInitialVendorDetailLoading(true);
    
    if (isView || vendorRequestMode !== VendorForm1Modes.VendorInitialCreate || requestNumber) {
      VendorDetailService.getVendorRequestData(
        requestNumber,
        vendorNo,
        coCode,
        poCodes && poCodes.length > 0 ? poCodes[0] : "",
        false,
        onVendorDataLoadSuccess,
        onVendorDataLoadFail
      );
    } else {
      getInitialMetaData(null); // only true create flow
    }
  }, []);

  // useEffect(() => {
  //   showLoadingMask();
  //   setIsInitialVendorDetailData(true);
  //   if (!requestNumber && vendorRequestMode === VendorForm1Modes.VendorInitialCreate) {
  //     getInitialMetaData(null);
  //   } else {
  //     VendorDetailService.getVendorRequestData(
  //       requestNumber,
  //       vendorNo,
  //       coCode,
  //       poCodes && poCodes.length > 0 ? poCodes[0] : "",
  //       false,
  //       onVendorDataLoadSuccess,
  //       onVendorDataLoadFail
  //     );
  //   }
  // }, []);

  useEffect(() => {
    if (createVendor.AddressCoutry && createVendor.AddressCoutry !== "") {
      if (!isInitialVendorDetailLoading) {
        showLoadingMask();
        Promise.allSettled([
          getPromisePreferedPaymentMethods(
            createVendor.CompanyCode,
            createVendor.AddressCoutry,
            (paymethodsList: Array<PaymentMethod>) => { setPaymentmethod(paymethodsList); },
            () => { setPaymentmethod([]); }
          ),
        ]).then(() => {
          if (!isInitialVendorDetailLoading && isEditableMode()) {
            compeleteRequest(true);
          }
        });
      }
    } else {
      setPaymentmethod([]);
    }
  }, [createVendor.AddressCoutry]);

  


  const isEditableMode = () => {
    if (isView) return false;

    return (
      vendorRequestMode === VendorForm1Modes.VendorInitialCreate ||
      vendorRequestMode === VendorForm1Modes.VendorInialAmend ||
      vendorRequestMode === VendorForm1Modes.VendorInialExtend ||
      vendorRequestMode === VendorForm1Modes.VendorInitialIndividualPay
    );
  };


  useEffect(() => {
    if (resetScreen) {
      setFistSubmitDone(false);
      setFormErrors([]);
      dispatch(
        AllActions.vendorCreationActions.resetRequestDetails(
          loginUserDetails.userName
        )
      );
      setResetScreen(false);
    }
  }, [resetScreen]);

  const handleVendorBlock = () => {
    history.push(NavigationPaths.VendorBlocking, {
      departmentList: departmentList,
      vendorId: vendorId,
      vendorNo: vendorNo,
      vendorType: createVendor.VendorType,
      coCode: coCode,
      poCodes: poCodes,
      requestNumber: requestNumber,
      relatedVendorCompanies: relatedVendorCompanies
    });
  };

  const handleVendorExtend = () => {
    navigateToVendorDetail(
      vendorId,
      vendorNo,
      coCode,
      "",
      requestId,
      false,
      VendorForm1Modes.VendorInialExtend,
      requestNumber
    );
  };

  const handleVendorIndividualPayment = () => {
    navigateToVendorDetail(
      vendorId,
      vendorNo,
      coCode,
      "",
      requestId,
      false,
      VendorForm1Modes.VendorInitialIndividualPay,
      requestNumber
    );
  };

  const handleVendorAmend = () => {
    showLoadingMask();
    compeleteRequest(true);
    setRequestchangeTitle(translation.vendorchangepopup_amend_title);
    setOpenRequestChange(true);
  };

  const filterOptionsOrderCurrency = createFilterOptions({
    stringify: (option: SettlementCurrency) => option.name,
  });

  const onRequestChangeConfirm = (vendorData: any) => {
    if (
      vendorRequestMode === VendorForm1Modes.VendorInialAmend &&
      !createVendor.IsVendorFillForm2 &&
      vendorData
    ) {
      navigateToVendorDetail(
        undefined,
        "",
        "",
        "",
        vendorData.requestId,
        false,
        VendorRequestViewMode.VendorAmend,
        vendorData.requestNo
      );
    } else {
      history.push(NavigationPaths.Dashboard);
    }
  };

  const handleRequestChangeClose = () => {
    setOpenRequestChange(false);
  };

  const handleChangeAutoCompete = (e: any, input: string, newValue: any) => {
    if (input === "AddressCoutry") {
      if (newValue) {
        handleChange("AddressCoutry")(e);
        updateCountryData(newValue.code);
      } else {
        //handleChange("AddressCoutry")(e);
        updateCountryData("");
      }
    } else if (input === "alternativeCurrency") {
      let selectedCodeList: string[] = [];
      if (newValue) {
        selectedCodeList = newValue.map(function (item: SettlementCurrency) {
          return item.code;
        });
      }
      if (newValue) {
        dispatch(
          AllActions.vendorCreationActions.updateDataField(input, selectedCodeList));
      } else {
        dispatch(AllActions.vendorCreationActions.updateDataField(input, []));
      }
    } else if (input === "orderCurrency") {
      dispatch(AllActions.vendorCreationActions.updateOrderCurrency(newValue ? newValue.code : ""));
    } else if (input === "InstructionKey") {
      let instructiondata: InstructionKey | undefined = { code: "", name: "" };
      if (newValue) {
        instructiondata = instructionkeys.find(function (item: InstructionKey) {
          return item.code === newValue.code;
        });
      }
      dispatch(AllActions.vendorCreationActions.updateDataField(input, newValue ? newValue.code : ""));
    }
  };

  const updateCountryData = (newValue: string) => {
    dispatch(AllActions.vendorCreationActions.updateDataField("AddressCoutry", newValue));
    dispatch(AllActions.vendorCreationActions.updateDataField("PrefPayMethod", []));
  };

  const concateDataList = (datalist: any) => {
    if (datalist && datalist.length > 0) {
      let concatstring = datalist.join(",");
      return concatstring;
    }
    return "";
  };

  const isFieldsAvailable = (fieldName: string) => {
    if (fieldName == "SettlementCurrencies") {
      return Common.getSapSystem() != "S4";
    }
  }

  const getPrcurementSubcategoryName = (subCategoryId: number) => {
    let sc = procurementSubcategories.find(r => r.procurmentSubcategoryId == subCategoryId);
    return sc ? (sc.procurmentCategoryName + '-' + sc.procurmentSubcategoryName) : '';
  }

  return (
    <div>
      <div>
        <div className={classes.contentOuterBG}>
          <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} className={classes.createHeader} >
            <span className={classes.createHeaderTxt}>
              {translation.vendor_crete_form1_requstor_section_title}
            </span>
            <span className={classes.createHeaderLine}></span>
          </Grid>
          <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} className={classes.createWrapper} >
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_crete_form1_requstor_lbl}
                </span>
              </Grid>
              <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
                {/* <select/> */}
                <span className={classes.textWrap}>
                  {createVendor.Requestory}
                </span>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_crete_form1_department_lbl}
                </span>
              </Grid>
              <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
                {vendorRequestMode ===
                  VendorForm1Modes.VendorInitialCreate ? (
                  <Select
                    variant="outlined"
                    value={createVendor.DepartmentId || ""}
                    onChange={handleChange("DepartmentId")}
                    error={getErrorState("DepartmentId")}
                  >
                    {departmentList.map((obj) => (
                      <MenuItem key={obj.id} value={obj.id}>
                        {obj.name}
                      </MenuItem>
                    ))}
                  </Select>
                ) : (
                  <span className={classes.textWrap}>
                    {createVendor.DepartmentName}
                  </span>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_crete_form1_comment_lbl}
                </span>
              </Grid>
              <Grid
                className={classes.inputWrapper}
              >
                <TextField
                  disabled={!isEditableMode()}
                  variant="outlined"
                  value={createVendor.Comment || ""}
                  onChange={handleChange("Comment")}
                  error={getErrorState("Comment")}
                  inputProps={{ maxLength: FieldsLengthConstants.RequestComments }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}
              className={createVendor.RequestTypeId == RequestTypes.VendorAmend ? classes.compDisableCls : ""}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_crete_form1_companycode_lbl}
                </span>
              </Grid>
              <Grid
                className={classes.inputWrapper_Req}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
              >
                {vendorRequestMode ===
                  VendorForm1Modes.VendorInitialCreate ? (
                  <Select
                    variant="outlined"
                    value={createVendor.CompanyCode || ""}
                    onChange={handleChange("CompanyCode")}
                    error={getErrorState("CompanyCode")}
                  >
                    {companyCodeList.map((obj) => (
                      <MenuItem key={obj.code} value={obj.code}>
                        {obj.name}
                      </MenuItem>
                    ))}
                  </Select>
                ) : (
                  <span className={classes.textWrap}>
                    {createVendor.CompanyCode}
                  </span>
                )}
              </Grid>
            </Grid>
            {!isRmOrNonRmOrServices() && (<Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_crete_form1_vendor_nominated_lbl}
                </span>
              </Grid>
              <Grid className={classes.inputWrapper}>
                <Select
                  disabled={!isEditableMode()}
                  variant="outlined"
                  value={createVendor.VendorNominatedBy || ""}
                  onChange={handleChange("VendorNominatedBy")}
                  error={getErrorState("VendorNominatedBy")}
                >
                  {vendorNominated.map((obj) => (
                    <MenuItem key={obj.code} value={obj.code}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>)}

            {vendorRequestMode !== VendorForm1Modes.VendorInitialCreate && (
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.vendor_crete_form1_vendor_no_lbl}
                  </span>
                </Grid>
                <Grid className={classes.inputWrapper_Req}>
                  <span className={classes.textWrap}>
                    {createVendor.vendorNo}
                  </span>
                </Grid>
              </Grid>
            )}
          </Grid>

          <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} className={classes.createHeader} >
            <span className={classes.createHeaderTxt}>
              {translation.vendor_crete_form1_vendornature_section_title}
            </span>
            <span className={classes.createHeaderLine}></span>
          </Grid>
          <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_crete_form1_vendornm_lbl}
                </span>
              </Grid>
              <Grid className={classes.inputWrapper_Req}>
                <TextField
                  disabled={!isEditableMode()}
                  variant="outlined"
                  rows="5"
                  value={createVendor.VendorName || ""}
                  onChange={handleChange("VendorName")}
                  error={getErrorState("VendorName")}
                  inputProps={{ maxLength: FieldsLengthConstants.VendorName }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}
              className={createVendor.RequestTypeId == RequestTypes.VendorAmend ? classes.compDisableCls : ""}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_crete_form1_vendorcategory_lbl}
                </span>
              </Grid>
              <Grid className={classes.inputWrapper_Req}>
                <Select
                  disabled={!isEditableMode()}
                  variant="outlined"
                  value={createVendor.VendorCategoryId || ""}
                  onChange={handleChange("VendorCategoryId")}
                  error={getErrorState("VendorCategoryId")}
                >
                  {vendorCategories.map((obj) => (
                    <MenuItem key={obj.name} value={obj.id}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>

            {(createVendor.VendorCategoryId == VendorCategoryData.RM) && (
              <Fragment>
                <Grid className={!isEditableMode ? classes.compDisableCls : ""} item container xs={12} sm={12} md={6} lg={4} >
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.formTwoLbl}>
                      {translation.vendor_crete_form1_BulkSample_lbl}
                    </span>
                  </Grid>
                  <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} style={{ width: "50%", float: "left" }}>
                    <div className={classes.switchDiv}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend"></FormLabel>
                        <RadioGroup row aria-label="Bulk/Sample" name="IsBulk" value={createVendor.IsBulk} onChange={handleChange("IsBulk")}>
                          <FormControlLabel disabled={!isEditableMode()} value={true} checked={createVendor.IsBulk === true} control={<Radio />} label="Bulk" />
                          <FormControlLabel disabled={!isEditableMode()} value={false} checked={createVendor.IsBulk === false} control={<Radio />} label="Sample" />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.createLbl}>
                      {translation.vendor_crete_form1_RMCategory_lbl}
                    </span>
                  </Grid>
                  <Grid className={classes.inputWrapper_Req}>
                    <Select
                      disabled={!isEditableMode()}
                      variant="outlined"
                      value={createVendor.RMCategoryIds[0] || 0}
                      onChange={handleChange("RMCategoryIds")}
                      error={getErrorState("RMCategoryIds")}
                    >
                      <MenuItem value="">
                        <em>{translation.dropdown_empty_text}</em>
                      </MenuItem>
                      {rmCategories.map((obj) => (
                        <MenuItem key={obj.id} value={obj.id}>
                          {obj.rmCategoryName}
                        </MenuItem>
                      ))}
                    </Select>
                    {/* <Select
                      disabled={!isEditableMode()}
                      variant="outlined"
                      multiple
                      value={createVendor.RMCategoryIds || []}
                      onChange={handleChange("RMCategoryIds")}
                      error={getErrorState("RMCategoryIds")}
                      renderValue={(selected) => (
                        <div>
                          {(selected as number[]).map((value) => (
                            <Chip
                              key={value}
                            // label={value}
                              label={rmCategories.find(r=> r.id == value)?.rmCategoryName}
                              clickable
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) => event.stopPropagation()}
                                />
                              }
                              onDelete={(e) => handleDelete(e, value, "RMCategoryIds")}
                            />
                          ))}
                        </div>
                      )}
                    >
                      {rmCategories.map((obj, index) => (
                        <MenuItem key={obj.id} value={obj.id}>
                          <Checkbox
                            checked={createVendor.RMCategoryIds.includes(obj.id)}
                          />
                          <ListItemText primary={obj.rmCategoryName} />
                        </MenuItem>
                      ))}
                    </Select> */}
                  </Grid>
                </Grid>
              </Fragment>
            )}
            {(isNonRmOrService(createVendor.VendorCategoryId)) && (
                <Fragment>
                  {/* <Grid item xs={12} sm={12} md={6} lg={4}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.createLbl}>
                      {translation.vendor_crete_form1_spend_managed_by_lbl}
                    </span>
                  </Grid>
                  <Grid className={classes.inputWrapper_Req}>
                    <Select
                      disabled={!isEditableMode()}
                      variant="outlined"
                      value={createVendor.SpendManagedById || ""}
                      onChange={handleChange("SpendManagedById")}
                      error={getErrorState("SpendManagedById")}
                    >
                      {spendManagedBys.map((obj, index) => (
                        <MenuItem key={obj.name} value={obj.id}>
                          {obj.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid> */}
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.createLbl}>
                        {translation.vendor_crete_form1_procurement_cat_lbl}
                      </span>
                    </Grid>
                    <Grid className={classes.inputWrapper_Req}>
                      <Select
                        disabled={!isEditableMode()}
                        variant="outlined"
                        value={createVendor.ProcurementCategoryIds[0] || 0}
                        onChange={handleChange("ProcurementCategoryIds")}
                        error={getErrorState("ProcurementCategoryIds")}
                      >
                        <MenuItem value="">
                          <em>{translation.dropdown_empty_text}</em>
                        </MenuItem>
                        {procurementCategories.map((obj) => (
                          <MenuItem key={obj.procurmentCategoryId} value={obj.procurmentCategoryId}>
                            {obj.procurmentCategoryName}
                          </MenuItem>
                        ))}
                      </Select>
                      {/* <Select
                        disabled={!isEditableMode()}
                        variant="outlined"
                        multiple
                        value={createVendor.ProcurementCategoryIds || []}
                        onChange={handleChange("ProcurementCategoryIds")}
                        error={getErrorState("ProcurementCategoryIds")}
                        renderValue={(selected) => (
                          <div>
                            {(selected as number[]).map((value) => (
                              <Chip
                                key={value}
                                // label={value}
                                label={procurementCategories.find(r => r.procurmentCategoryId == value)?.procurmentCategoryName}
                                clickable
                                deleteIcon={
                                  <CancelIcon
                                    onMouseDown={(event) => event.stopPropagation()}
                                  />
                                }
                                onDelete={(e) => handleDelete(e, value, "ProcurementCategoryIds")}
                              />
                            ))}
                          </div>
                        )}
                      >
                        {procurementCategories.map((obj) => (
                          <MenuItem key={obj.procurmentCategoryId} value={obj.procurmentCategoryId}>
                            <Checkbox
                              checked={createVendor.ProcurementCategoryIds.includes(obj.procurmentCategoryId)}
                            />
                            <ListItemText primary={obj.procurmentCategoryName} />
                          </MenuItem>
                        ))}
                      </Select> */}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.createLbl}>
                        {translation.vendor_crete_form1_procurement_subcat_lbl}
                      </span>
                    </Grid>
                    <Grid className={classes.inputWrapper_Req}>
                      <Select
                        disabled={!isEditableMode()}
                        variant="outlined"
                        value={createVendor.ProcurementSubcategoryIds[0] || 0}
                        onChange={handleChange("ProcurementSubcategoryIds")}
                        error={getErrorState("ProcurementSubcategoryIds")}
                      >
                        <MenuItem value="">
                          <em>{translation.dropdown_empty_text}</em>
                        </MenuItem>
                        {procurementSubcategories.map((obj) => (
                          <MenuItem key={obj.procurmentSubcategoryId} value={obj.procurmentSubcategoryId}>
                            {MasterDataUtil.getNameFromProcSubCategorName(obj.procurmentSubcategoryName)}
                          </MenuItem>
                        ))}
                      </Select>
                      <span className={classes.helpLbl}>{
                        MasterDataUtil.getSpendMngByFromProcSubCategorId(procurementSubcategories
                        ,createVendor.ProcurementSubcategoryIds[0] || 0)}
                      </span>
                      {/* <Select
                        disabled={!isEditableMode()}
                        variant="outlined"
                        multiple
                        value={createVendor.ProcurementSubcategoryIds || []}
                        onChange={handleChange("ProcurementSubcategoryIds")}
                        error={getErrorState("ProcurementSubcategoryIds")}
                        renderValue={(selected) => (
                          <div>
                            {(selected as number[]).map((value) => (
                              <Chip
                                key={value}
                                // label={value}
                                label={getPrcurementSubcategoryName(value)}
                                clickable
                                deleteIcon={
                                  <CancelIcon
                                    onMouseDown={(event) => event.stopPropagation()}
                                  />
                                }
                                onDelete={(e) => handleDelete(e, value, "ProcurementSubcategoryIds")}
                              />
                            ))}
                          </div>
                        )}
                      >
                        {procurementSubcategories.map((obj) => (
                          <MenuItem key={obj.procurmentSubcategoryId} value={obj.procurmentSubcategoryId}>
                            <Checkbox
                              checked={createVendor.ProcurementSubcategoryIds.includes(obj.procurmentSubcategoryId)}
                            />
                            <ListItemText primary={getPrcurementSubcategoryName(obj.procurmentSubcategoryId)} />
                          </MenuItem>
                        ))}
                      </Select> */}
                    </Grid>
                  </Grid>
                </Fragment>
              )}
            {isRmOrNonRmOrServices() && (
              <Fragment>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.createLbl}>
                      {translation.vendor_crete_form1_OnBoard_Reason_lbl}
                    </span>
                  </Grid>
                  <Grid className={classes.inputWrapper_Req}>
                    <Select
                      disabled={!isEditableMode()}
                      variant="outlined"
                      multiple
                      value={createVendor.OnBoardReasonIds || []}
                      onChange={handleChange("OnBoardReasonIds")}
                      error={getErrorState("OnBoardReasonIds")}
                      renderValue={(selected) => (
                        <div>
                          {(selected as number[]).map((value) => (
                            <Chip
                              key={value}
                              label={vendorOnboardingReasons.find(r => r.id == value)?.vendorOnboardingReasonName}
                              clickable
                              deleteIcon={
                                isEditableMode() ? <CancelIcon
                                  onMouseDown={(event) => event.stopPropagation()}
                                /> : undefined


                              }
                              onDelete={isEditableMode() ? (e) => handleDelete(e, value, "OnBoardReasonIds") : undefined}
                            />
                          ))}
                        </div>
                      )}
                    >
                      {vendorOnboardingReasons.map((obj) => (
                        <MenuItem key={obj.id} value={obj.id}>
                          <Checkbox
                            disabled={!isOnboardingReasonActive(obj.id)}
                            checked={createVendor.OnBoardReasonIds.includes(obj.id)}
                          />
                          <ListItemText primary={obj.vendorOnboardingReasonName} />
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.createLbl}>
                      {translation.vendor_crete_form1_OBRDescript_lbl}
                    </span>
                  </Grid>
                  <Grid className={createVendor.VendorCategoryId == VendorCategoryData.RM ? classes.inputWrapper_Req : classes.inputWrapper}>
                    <TextField
                      multiline
                      maxRows={4}
                      disabled={!isEditableMode()}
                      variant="outlined"
                      value={createVendor.OnBoardReasonDescription || ""}
                      onChange={handleChange("OnBoardReasonDescription")}
                      error={getErrorState("OnBoardReasonDescription")}
                      inputProps={{ maxLength: FieldsLengthConstants.VendoOnboardDescript }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} >
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.formTwoLbl}>
                      {translation.vendor_create_onboardreasonupload_lbl}
                    </span>
                  </Grid>
                  <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
                    <div className={classes.fileWrapper}>
                      <FileUpload
                        editable={isEditableMode()}
                        requestNumber={createVendor.RequestNumber || requestNumber}
                        userfile={createVendor.OnboardReasonFile}
                        attachmentType={FileUploadTypes.OnboardingReasonDoc}
                        //isNoUpload={true}
                        acceptTypes=".eml, .docx, .pptx, .xlsx, .ods, .pdf"
                      ></FileUpload>
                    </div>
                  </Grid>
                </Grid>
              </Fragment>
            )}
            <Grid item xs={12} sm={12} md={6} lg={4}
              className={createVendor.RequestTypeId == RequestTypes.VendorAmend ? classes.compDisableCls : ""}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_crete_form1_vendortype_lbl}
                </span>
              </Grid>
              <Grid className={classes.inputWrapper_Req}>
                <Select
                  disabled={!isEditableMode()}
                  variant="outlined"
                  value={createVendor.VendorType || ""}
                  onChange={handleChange("VendorType")}
                  error={getErrorState("VendorType")}
                >
                  {filteredVendorTypes.map((obj) => (
                    <MenuItem key={obj.code} value={obj.code}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_crete_form1_recon_lbl}
                </span>
              </Grid>
              <Grid className={classes.inputWrapper_Req}>
                <Select
                  disabled={!isEditableMode()}
                  variant="outlined"
                  value={createVendor.ReconAC || ""}
                  onChange={handleChange("ReconAC")}
                  error={getErrorState("ReconAC")}
                >
                  {reconAcList.map((obj) => (
                    <MenuItem key={obj.code} value={obj.code}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_crete_form1_subcategory_lbl}
                </span>
              </Grid>
              <Grid className={classes.inputWrapper_Req}>
                <Select
                  disabled={!isEditableMode()}
                  variant="outlined"
                  value={createVendor.TypeSubCategory || ""}
                  onChange={handleChange("TypeSubCategory")}
                  error={getErrorState("TypeSubCategory")}
                >
                  {secondCategories.map((obj) => (
                    <MenuItem key={obj.code} value={obj.code}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_detail_contactdetails_country_lbl}
                </span>
              </Grid>
              <Grid className={classes.inputWrapper_Req}>
                <Autocomplete
                  disabled={!isEditableMode()}
                  options={countries.map((obj: Country) => obj)}
                  getOptionLabel={(option) => option.name}
                  onChange={(e, newValue) => {
                    e.preventDefault();
                    handleChangeAutoCompete(e, "AddressCoutry", newValue);
                  }}
                  value={
                    countries.find(
                      (element: Country) =>
                        element.code === createVendor.AddressCoutry
                    ) || null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="normal"
                      variant="outlined"
                      error={getErrorState("AddressCoutry")}
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""} >
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_detail_paymentdetails_paymethod_lbl}
                </span>
              </Grid>
              <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
                <Select
                  disabled={!isEditableMode()}
                  variant="outlined"
                  multiple
                  value={createVendor.PrefPayMethod || []}
                  onChange={handleChange("PrefPayMethod")}
                  error={getErrorState("PrefPayMethod")}
                  renderValue={(selected) => (
                    <div>
                      {(selected as string[]).map((value) => (
                        <Chip
                          key={value}
                          label={value}
                          clickable
                          deleteIcon={isEditableMode() ? (
                            <CancelIcon
                              onMouseDown={(event) => event.stopPropagation()}
                            />) : undefined
                          }
                          onDelete={isEditableMode() ? (e) => handleDelete(e, value, "PrefPayMethod") : undefined}
                        />
                      ))}
                    </div>
                  )}
                >
                  {paymentmethod.map((obj: PaymentMethod) => (
                    <MenuItem key={obj.code} value={obj.code}>
                      <Checkbox
                        checked={createVendor.PrefPayMethod.includes(obj.code)}
                      />
                      <ListItemText primary={obj.name} />
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""} >
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_detail_paymentdetails_credperiod_lbl}
                </span>
              </Grid>
              <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
                <Select
                  disabled={!isEditableMode()}
                  variant="outlined"
                  value={createVendor.CreditPeriodDays || ""}
                  onChange={handleChange("CreditPeriodDays")}
                  error={getErrorState("CreditPeriodDays")}
                >
                  {crediperioddays.map((obj: CreditPeriodDays) => (
                    <MenuItem key={obj.code} value={obj.code}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
            {isRmOrNonRmOrServices() && (
              <Fragment>
                <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""} >
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.createLbl}>
                      {translation.vendor_detail_bankdetails_purposecode_lbl}
                    </span>
                  </Grid>
                  <Grid className={classes.inputWrapper} item xs={12} sm={12} md={12} lg={12} >
                    <Select
                      disabled={!isEditableMode()}
                      variant="outlined"
                      value={createVendor.purposeCode || ""}
                      onChange={handleChange("purposeCode")}
                      error={getErrorState("purposeCode")}
                    >
                      <MenuItem value="">
                        <em>{translation.dropdown_empty_text}</em>
                      </MenuItem>
                      {paymentpurposes.map((obj: PaymentPurpose) => (
                        <MenuItem key={obj.code} value={obj.code}>
                          {obj.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""} >
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.createLbl}>
                      {translation.individualPayPopup_instruction_key_lbl}
                    </span>
                  </Grid>
                  <Grid className={classes.inputWrapper} item xs={12} sm={12} md={12} lg={12} >
                    <Autocomplete
                      disabled={!isEditableMode()}
                      options={instructionkeys.map((obj) => obj)}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, newValue) => {
                        e.preventDefault();
                        handleChangeAutoCompete(e, "InstructionKey", newValue);
                      }}
                      value={
                        instructionkeys.find((element) =>
                          element.code === createVendor.InstructionKey) || null
                      }
                      renderOption={(option, props) => (
                        <li {...props}>
                          {option.name}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="normal"
                          error={getErrorState("InstructionKey")}
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Fragment>
            )
            }

            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_crete_form1_mobilenum_lbl}
                </span>
              </Grid>
              <Grid className={classes.inputWrapper_Req}>
                <Tooltip title={translation.vendor_crete_form1_mobilenum_tooltip} placement="bottom-start">
                  <TextField
                    disabled={!isEditableMode()}
                    variant="outlined"
                    value={createVendor.MobileNumber || ""}
                    onChange={handleChange("MobileNumber")}
                    error={getErrorState("MobileNumber")}
                    inputProps={{
                      maxLength: FieldsLengthConstants.VendorMobileNumber
                    }}
                  />
                </Tooltip>
                <span className={classes.helpLbl}>{translation.vendor_crete_form1_mobilenum_help}</span>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                  {translation.vendor_crete_form1_email_lbl}
                </span>
              </Grid>
              <Grid
                //className={classes.inputWrapper}
                className={
                  createVendor.IsVendorFillForm2
                    ? classes.inputWrapper_Req
                    : classes.inputWrapper
                }
              >
                <TextField
                  disabled={!isEditableMode()}
                  variant="outlined"
                  value={createVendor.Email || ""}
                  onChange={handleChange("Email")}
                  error={getErrorState("Email")}
                  inputProps={{ maxLength: FieldsLengthConstants.VendorEmail }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <span
                  className={classes.createLbl}
                  style={{ margin: "30px 0 0 0" }}
                >
                  {translation.vendor_crete_form1_isforensup_lbl}
                </span>
              </Grid>
              <Grid
                className={classes.inputWrapper}
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
              >
                <Checkbox
                  disabled={!isEditableMode()}
                  checked={createVendor.isForeignSupplier}
                  onChange={handleChange("isForeignSupplier")}
                  style={{ margin: "8px 0 0 0" }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <span
                  className={classes.createLbl}
                  style={{ margin: "30px 0 0 0" }}
                >
                  {translation.vendor_crete_form1_vendorfillsform2_lbl}
                </span>
              </Grid>
              <Grid
                className={classes.inputWrapper}
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
              >
                <Checkbox
                  disabled={!isEditableMode()}
                  checked={createVendor.IsVendorFillForm2}
                  onChange={handleChange("IsVendorFillForm2")}
                  style={{ margin: "8px 0 0 0" }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <span className={classes.createLbl} style={{ margin: "30px 0 0 0" }} >
                  {translation.dashboard_approve_isuserurgent}
                </span>
              </Grid>
              <Grid className={classes.inputWrapper} item xs={12} sm={12} md={6} lg={6} >
                <Checkbox
                  disabled={!isEditableMode()}
                  checked={createVendor.IsUrgentRequest}
                  onChange={handleChange("IsUrgentRequest")}
                  style={{ margin: "8px 0 0 0" }}
                />
              </Grid>
            </Grid>
          </Grid>
          {isRmOrNonRm(createVendor.VendorCategoryId) && (
            <Fragment>
              <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} className={classes.createHeader} >
                <span className={classes.createHeaderTxt}>
                  {translation.vendor_crete_form1_purch_org_title}
                </span>
                <span className={classes.createHeaderLine}></span>
              </Grid>
              <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.createLbl}>
                      {translation.vendor_crete_form1_purchorg_lbl}
                    </span>
                  </Grid>
                  <Grid className={isPoRequired() ? classes.inputWrapper_Req : classes.inputWrapper} item xs={12} sm={12} md={12} lg={12} >
                    {vendorRequestMode ===
                      VendorForm1Modes.VendorInitialCreate ? (
                      <Select                        
                        variant="outlined"
                        multiple
                        value={createVendor.PoCodes || []}
                        onChange={handleChange("PoCodes")}
                        error={getErrorState("PoCodes")}
                        renderValue={(selected) => (
                          <div>
                            {(selected as string[]).map((value) => (
                              <Chip
                                key={value}
                                label={value}
                                clickable
                                deleteIcon={
                                  <CancelIcon
                                    onMouseDown={(event) => event.stopPropagation()}
                                  />
                                }
                                onDelete={(e) => handleDelete(e, value, "PoCodes")}
                              // onClick={() => console.log("clicked chip")}
                              />
                            ))}
                          </div>
                        )}
                      >
                        {filteredPoList.map((obj) => (
                          <MenuItem key={obj.code} value={obj.code}>
                            <Checkbox
                              checked={createVendor.PoCodes.includes(obj.code)}
                            />
                            <ListItemText primary={obj.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    ) : (
                      <span className={classes.textWrap}>
                        {concateDataList(createVendor.PoCodes)}
                      </span>
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""} >
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.createLbl}>
                      {translation.vendor_detail_paymentdetails_termtrd_lbl}
                    </span>
                  </Grid>
                  <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
                    <Select
                      disabled={!isEditableMode()}
                      variant="outlined"
                      value={createVendor.TermsOfTrade || ""}
                      onChange={handleChange("TermsOfTrade")}
                      error={getErrorState("TermsOfTrade")}
                    >
                      {termstrade.map((obj: TermsTrade) => (
                        <MenuItem key={obj.code} value={obj.code}>
                          {obj.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""} >
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.createLbl}>
                      {translation.vendor_detail_paymentdetails_currencyorder_lbl}
                    </span>
                  </Grid>
                  <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
                    <Autocomplete
                      disabled={!isEditableMode()}
                      options={settlementcurrency.map(
                        (obj: SettlementCurrency) => obj
                      )}
                      getOptionLabel={(option) => option.code}
                      filterOptions={filterOptionsOrderCurrency}
                      onChange={(e, newValue) => {
                        e.preventDefault();
                        handleChangeAutoCompete(e, "orderCurrency", newValue);
                      }}
                      value={
                        settlementcurrency.find(
                          (element: SettlementCurrency) =>
                            element.code === createVendor.orderCurrency
                        ) || null
                      }
                      renderOption={(option) => option.name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="normal"
                          variant="outlined"
                          error={getErrorState("orderCurrency")}
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}
                    />
                    <span className={classes.helpLbl}>{translation.vendor_detail_paymentdetails_currencyorder_help}</span>
                  </Grid>
                </Grid>
                {isFieldsAvailable("SettlementCurrencies") && (
                  <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode || !createVendor.orderCurrency ? classes.compDisableCls : ""} >
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.createLbl}>
                        {translation.vendor_detail_paymentdetails_currencyst_lbl}
                      </span>
                    </Grid>
                    <Grid className={classes.inputWrapper} item xs={12} sm={12} md={12} lg={12} >
                      <Autocomplete
                        disabled={!isEditableMode()}
                        multiple
                        options={settlementcurrency.filter(
                          (element: SettlementCurrency) => {
                            return createVendor.orderCurrency !== element.code;
                          }
                        )}
                        disableCloseOnSelect
                        value={
                          settlementcurrency.filter((element: SettlementCurrency) =>
                            createVendor.alternativeCurrency.includes(element.code)
                          ) || null
                        }
                        getOptionLabel={(option) => option.name}
                        onChange={(e, newValue) => {
                          e.preventDefault();
                          handleChangeAutoCompete(e, "alternativeCurrency", newValue);
                        }}
                        renderOption={(option, { selected }) => (
                          <React.Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.name}
                          </React.Fragment>
                        )}
                        renderTags={(value: SettlementCurrency[], getTagProps) =>
                          value.map((option: SettlementCurrency, index: number) => (
                            <Chip label={option.code} {...getTagProps({ index })} />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            error={getErrorState("alternativeCurrency")}
                            inputProps={{
                              ...params.inputProps,
                            }}
                          />
                        )}
                      />
                      <span className={classes.helpLbl}>{translation.vendor_detail_paymentdetails_currencyst_help}</span>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Fragment>
          )}
          {isEditableMode() && approver1List && approver1List.length > 0 && (
            <Fragment>
              <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} className={classes.createHeader} >
                <span className={classes.createHeaderTxt}>
                  {translation.vendor_crete_form1_approvers_section_title}
                </span>
                <span className={classes.createHeaderLine}></span>
              </Grid>
              <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.createLbl}>{approver1Lable}</span>
                  </Grid>
                  <Grid className={classes.inputWrapper_Req}>
                    {(!isRmOrNonRmOrServices() || isServicesBySbu()) && (
                    <Select
                      disabled={!isEditableMode()}
                      variant="outlined"
                      multiple
                      value={createVendor.FirstApprovers || []}
                      onChange={handleChange("FirstApprovers")}
                      error={getErrorState("FirstApprovers")}
                      renderValue={(selected) => (
                        <div>
                          {(selected as string[]).map((value) => (
                            <Chip
                              key={value}
                              label={value}
                              clickable
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) => event.stopPropagation()}
                                />
                              }
                              onDelete={(e) => handleDelete(e, value, "FirstApprovers")}
                            />
                          ))}
                        </div>
                      )}
                    >
                      {approver1List.map((obj) => (
                        <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                          <Checkbox
                            checked={createVendor.FirstApprovers.includes(obj.emailAddress)}
                          />
                          <ListItemText primary={obj.emailAddress} />
                        </MenuItem>
                      ))}
                    </Select>)}
                    {(isRmOrNonRmOrServices() && !isServicesBySbu()) && (
                      <span className={classes.textWrap}>
                        {`${approver1List.map((obj) => obj.emailAddress + ' ')}`}
                      </span>
                    )}
                  </Grid>
                </Grid>
                {approver2List.length > 0 && (<Grid item xs={12} sm={12} md={6} lg={4}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.createLbl}>{approver2Lable}</span>
                  </Grid>
                  <Grid className={classes.inputWrapper_Req}>
                    {!isRmOrNonRmOrServices() && (<Select
                      disabled={!isEditableMode()}
                      variant="outlined"
                      multiple
                      value={createVendor.SecondApprovers || []}
                      onChange={handleChange("SecondApprovers")}
                      error={getErrorState("SecondApprovers")}
                      renderValue={(selected) => (
                        <div>
                          {(selected as string[]).map((value) => (
                            <Chip
                              key={value}
                              label={value}
                              clickable
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) => event.stopPropagation()}
                                />
                              }
                              onDelete={(e) => handleDelete(e, value, "SecondApprovers")}
                            />
                          ))}
                        </div>
                      )}
                    >
                      {approver2List.map((obj) => (
                        <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                          <Checkbox
                            checked={createVendor.SecondApprovers.includes(obj.emailAddress)}
                          />
                          <ListItemText primary={obj.emailAddress} />
                        </MenuItem>
                      ))}
                    </Select>)}
                    {isRmOrNonRmOrServices() && (
                      <span className={classes.textWrap}>
                        {`${approver2List.map((obj) => obj.emailAddress + ' ')}`}
                      </span>
                    )}
                  </Grid>
                </Grid>)}
                {/* {(createVendor.VendorCategoryId == VendorCategoryData.RM) && (
                  <Fragment> 
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.vendor_crete_form1_CatLead_approver_lbl}
                        </span>
                      </Grid>
                      <Grid className={classes.inputWrapper_Req}>
                        <Select
                          disabled={!isEditableMode()}
                          variant="outlined"
                          multiple
                          value={createVendor.GSSCCategoryLeadApprovers || []}
                          onChange={handleChange("GSSCCategoryLeadApprovers")}
                          error={getErrorState("GSSCCategoryLeadApprovers")}
                          renderValue={(selected) => (
                            <div>
                              {(selected as string[]).map((value) => (
                                <Chip
                                  key={value}
                                  label={value}
                                  clickable
                                  deleteIcon={
                                    <CancelIcon
                                      onMouseDown={(event) => event.stopPropagation()}
                                    />
                                  }
                                  onDelete={(e) => handleDelete(e, value, "GSSCCategoryLeadApprovers")}
                                />
                              ))}
                            </div>
                          )}
                        >
                          {gSSCCategoryLeadList.map((obj, index) => (
                            <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                              <Checkbox
                                checked={createVendor.GSSCCategoryLeadApprovers.includes(obj.emailAddress)}
                              />
                              <ListItemText primary={obj.emailAddress} />
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.vendor_crete_form1_sbu_approver_lbl}
                        </span>
                      </Grid>
                      <Grid className={classes.inputWrapper_Req}>
                        <Select
                          disabled={!isEditableMode()}
                          variant="outlined"
                          multiple
                          value={createVendor.SBUSCHeadApprovers || []}
                          onChange={handleChange("SBUSCHeadApprovers")}
                          error={getErrorState("SBUSCHeadApprovers")}
                          renderValue={(selected) => (
                            <div>
                              {(selected as string[]).map((value) => (
                                <Chip
                                  key={value}
                                  label={value}
                                  clickable
                                  deleteIcon={
                                    <CancelIcon
                                      onMouseDown={(event) => event.stopPropagation()}
                                    />
                                  }
                                  onDelete={(e) => handleDelete(e, value, "SBUSCHeadApprovers")}
                                />
                              ))}
                            </div>
                          )}
                        >
                          {sBUSCHeadList.map((obj, index) => (
                            <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                              <Checkbox
                                checked={createVendor.SBUSCHeadApprovers.includes(obj.emailAddress)}
                              />
                              <ListItemText primary={obj.emailAddress} />
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                  </Fragment>   
                )} */}
                {/* {(createVendor.VendorCategoryId == VendorCategoryData.RM 
                  || createVendor.VendorCategoryId === VendorCategoryData.NonRM
                  || createVendor.VendorCategoryId === VendorCategoryData.Services) && (
                  <Fragment> 
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.vendor_crete_form1_CatLead_approver_lbl}
                        </span>
                      </Grid>
                      <Grid className={classes.inputWrapper_Req}>
                        <Select
                          disabled={!isEditableMode()}
                          variant="outlined"
                          multiple
                          value={createVendor.GSSCCategoryLeadApprovers || []}
                          onChange={handleChange("GSSCCategoryLeadApprovers")}
                          error={getErrorState("GSSCCategoryLeadApprovers")}
                          renderValue={(selected) => (
                            <div>
                              {(selected as string[]).map((value) => (
                                <Chip
                                  key={value}
                                  label={value}
                                  clickable
                                  deleteIcon={
                                    <CancelIcon
                                      onMouseDown={(event) => event.stopPropagation()}
                                    />
                                  }
                                  onDelete={(e) => handleDelete(e, value, "GSSCCategoryLeadApprovers")}
                                />
                              ))}
                            </div>
                          )}
                        >
                          {gSSCCategoryLeadList.map((obj, index) => (
                            <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                              <Checkbox
                                checked={createVendor.GSSCCategoryLeadApprovers.includes(obj.emailAddress)}
                              />
                              <ListItemText primary={obj.emailAddress} />
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.vendor_crete_form1_sbu_approver_lbl}
                        </span>
                      </Grid>
                      <Grid className={classes.inputWrapper_Req}>
                        <Select
                          disabled={!isEditableMode()}
                          variant="outlined"
                          multiple
                          value={createVendor.SBUSCHeadApprovers || []}
                          onChange={handleChange("SBUSCHeadApprovers")}
                          error={getErrorState("SBUSCHeadApprovers")}
                          renderValue={(selected) => (
                            <div>
                              {(selected as string[]).map((value) => (
                                <Chip
                                  key={value}
                                  label={value}
                                  clickable
                                  deleteIcon={
                                    <CancelIcon
                                      onMouseDown={(event) => event.stopPropagation()}
                                    />
                                  }
                                  onDelete={(e) => handleDelete(e, value, "SBUSCHeadApprovers")}
                                />
                              ))}
                            </div>
                          )}
                        >
                          {sBUSCHeadList.map((obj, index) => (
                            <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                              <Checkbox
                                checked={createVendor.SBUSCHeadApprovers.includes(obj.emailAddress)}
                              />
                              <ListItemText primary={obj.emailAddress} />
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                  </Fragment>   
                )}         */}
              </Grid>
            </Fragment>)
          }
        </div>
      </div>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <div className={classes.BtnArea}>
          <div className={classes.reqLbl}>
            <span>{translation.vendor_crete_form1_reuired_txt}</span>
          </div>
          <div
            hidden={
              !(vendorRequestMode === VendorForm1Modes.VendorInialBlock)
            }
            className={classes.BtnBlackWrapper}
          >
            <Button onClick={handleVendorBlock}>
              {translation.vendor_crete_form1_block_btn}
            </Button>
          </div>
          <div
            hidden={
              !(vendorRequestMode === VendorForm1Modes.VendorInialExtend)
            }
            className={classes.BtnBlackWrapper}
          >
            <Button onClick={handleVendorExtend}>
              {translation.vendor_crete_form1_extend_btn}
            </Button>
          </div>
          <div
            hidden={
              !(vendorRequestMode === VendorForm1Modes.VendorInitialIndividualPay)
            }
            className={classes.BtnBlackWrapper}
          >
            <Button onClick={handleVendorIndividualPayment}>
              {translation.vendor_crete_form1_individual_payment_btn}
            </Button>
          </div>

          <div
            hidden={
              !(vendorRequestMode === VendorForm1Modes.VendorInialAmend)
            }
            className={classes.BtnBlackWrapper}
          >
            <Button onClick={handleVendorAmend}>
              {translation.vendor_crete_form1_amend_btn}
            </Button>
          </div>
          <div
            hidden={
              !(vendorRequestMode === VendorForm1Modes.VendorInitialCreate)
            }
            className={classes.BtnGreenWrapper}
          >
            <Button onClick={handleSubmit}>
              <CheckCircleIcon></CheckCircleIcon>
              {translation.vendor_crete_form1_submit_btn}
            </Button>
          </div>
        </div>
      </Grid>
      <ValidationErrors
        open={openValidateErrDialog}
        setOpen={setOpenValidateErrDialog}
        errorList={formErrors}
      ></ValidationErrors>
      {/* <UnBlockingPopUp open={openUnblock} onUpdateConfirm={onUnblockingConfirm}
          vendorId={vendorId} companyCodeList= {unBlockedcompanyCodeList} handleClose={handleUnlockClose}></UnBlockingPopUp> */}
      <RequestChangePopUp
        open={openRequestChange}
        requestMode={requestChangeMode as VendorForm1Modes}
        title={requestchangeTitle}
        onUpdateConfirm={onRequestChangeConfirm}
        vendorId={vendorId}
        vendorNo={createVendor.vendorNo}
        companyCodeList={[]}
        departmentList={departmentList}
        companyCode={createVendor.CompanyCode}
        poCodeList={createVendor.PoCodes}
        vendorType={createVendor.VendorType}
        handleClose={handleRequestChangeClose}
        countries={countries}
        getPreferedPaymentMethods={getPromisePreferedPaymentMethods}
        rmCategoryList={rmCategories}
        procurementCategoryList={procurementCategories}
        procurementSubCategorySummaryList={procurementSubCategorySummaries}
        onboardingReasonList={vendorOnboardingReasons}
        instructionKeyList={instructionkeys}
        paymentpurposeList={ paymentpurposes }
        secondLevelCategories={secondCategories}
      //approver1Lable={approver1Lable}
      //approver2Lable={approver2Lable}
      //approver1List={approver1List}
      //approver2List={approver2List}
      ></RequestChangePopUp>
    </div>
  );
}
